import { createSlice } from "@reduxjs/toolkit";

const degreeSlice = createSlice({
  name: "degree",
  initialState: {
    degrees: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    // Fetch degrees actions
    fetchDegreesStart(state) {
      state.degrees.loading = true;
      state.degrees.error = null;
    },
    fetchDegreesSuccess(state, action) {
      state.degrees.loading = false;
      state.degrees.data = action.payload;
    },
    fetchDegreesFailure(state, action) {
      state.degrees.loading = false;
      state.degrees.error = action.payload;
    },

    // Add degree actions
    addDegreeStart(state) {
      state.degrees.loading = true;
      state.degrees.error = null;
    },
    addDegreeSuccess(state, action) {
      state.degrees.loading = false;
      state.degrees.data = [...state.degrees.data, action.payload];
    },
    addDegreeFailure(state, action) {
      state.degrees.loading = false;
      state.degrees.error = action.payload;
    },

    // Update degree actions
    updateDegreeStart(state) {
      state.degrees.loading = true;
      state.degrees.error = null;
    },
    updateDegreeSuccess(state, action) {
      state.degrees.loading = false;
      const index = state.degrees.data.findIndex(
        (degree) => degree.id === action.payload.id
      );
      if (index !== -1) {
        state.degrees.data[index] = action.payload;
      }
    },
    updateDegreeFailure(state, action) {
      state.degrees.loading = false;
      state.degrees.error = action.payload;
    },

    // Delete degree actions
    deleteDegreeStart(state) {
      state.degrees.loading = true;
      state.degrees.error = null;
    },
    deleteDegreeSuccess(state, action) {
      state.degrees.loading = false;
      state.degrees.data = state.degrees.data.filter(
        (degree) => degree.id !== action.payload
      );
    },
    deleteDegreeFailure(state, action) {
      state.degrees.loading = false;
      state.degrees.error = action.payload;
    },
    fetchDegreeNamesStart(state) {
      state.degrees.loading = true;
      state.degrees.error = null;
    },
    fetchDegreeNamesSuccess(state, action) {
      state.degrees.loading = false;
      state.degrees.data = action.payload;
    },
    fetchDegreeNamesFailure(state, action) {
      state.degrees.loading = false;
      state.degrees.error = action.payload;
    },
  },
});

export const {
  fetchDegreesStart,
  fetchDegreesSuccess,
  fetchDegreesFailure,
  addDegreeStart,
  addDegreeSuccess,
  addDegreeFailure,
  updateDegreeStart,
  updateDegreeSuccess,
  updateDegreeFailure,
  deleteDegreeStart,
  deleteDegreeSuccess,
  deleteDegreeFailure,
  fetchDegreeNamesStart,
  fetchDegreeNamesSuccess,
  fetchDegreeNamesFailure
} = degreeSlice.actions;

export default degreeSlice.reducer;
